import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api/public/')) {
    return next(req);
  }
  const router = inject(Router);
  const isSessionCheck = req.url.includes('/auth/me');
  return next(req.clone({ withCredentials: true })).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !isSessionCheck) {
        router.navigate(['/login']);
      }
      return throwError(() => err);
    }),
  );
};
